import Button from "@mui/material/Button";
import Fade from "@mui/material/Fade";
import Link from "@mui/material/Link";
import MuiPaper from "@mui/material/Paper";
import Snackbar from "@mui/material/Snackbar";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import { Cookie } from "@phosphor-icons/react/Cookie";
import { paths } from "config/paths";
import { motion } from "framer-motion";
import NextLink from "next/link";
import { FC } from "react";

export interface CookiesSnackProps {
	open?: boolean;
	onAccept: () => void;
	onClose: () => void;
}

const Paper = motion(MuiPaper);

export const CookiesSnack: FC<CookiesSnackProps> = ({
	open = true,
	onAccept,
	onClose,
}) => {
	return (
		<Snackbar
			id="cookies-snack"
			open={open}
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "left",
			}}
			TransitionComponent={Fade}>
			<Paper sx={{ borderRadius: 2, p: 2 }}>
				<Stack direction="column">
					<Stack
						direction="row"
						alignItems="center"
						gap={1}>
						<SvgIcon
							component={Cookie}
							weight="duotone"
							inheritViewBox
							sx={{ width: 32, height: 32 }}
						/>
						<Typography
							component="h6"
							variant="subtitle1">
							We use cookies
						</Typography>
					</Stack>
					<Stack
						ml={5}
						gap={1}>
						<Typography
							component="p"
							variant="subtitle2"
							fontWeight={400}>
							To ensure that we give you the best experience on our website.{" "}
							<br />
							Read our{" "}
							<Link
								component={NextLink}
								color="primary"
								href={paths.privacy}
								underline="always">
								Privacy Policy
							</Link>
						</Typography>

						<Stack
							direction="row"
							gap={1}>
							<Button
								sx={{ flex: 1 }}
								variant="contained"
								onClick={onClose}
								color="inherit"
								disableElevation>
								Reject All
							</Button>
							<Button
								sx={{ flex: 1 }}
								variant="contained"
								color="primary"
								onClick={onAccept}
								disableElevation>
								Accept All
							</Button>
						</Stack>
					</Stack>
				</Stack>
			</Paper>
		</Snackbar>
	);
};
